"use client";

import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import {
  dismissAllMultipleModelWarningToasts,
  hasMultipleModelWarningToasts,
  subscribeMultipleModelWarningToasts,
} from "@/utils/multiple-model-warning-toast";

function ToastNotification() {
  const [showDismissWarningsButton, setShowDismissWarningsButton] = useState(
    hasMultipleModelWarningToasts(),
  );

  useEffect(() => {
    const unsubscribe = subscribeMultipleModelWarningToasts((count) => {
      setShowDismissWarningsButton(count > 0);
    });

    return unsubscribe;
  }, []);

  return (
    <div className="toaster-wrapper text-base">
      {showDismissWarningsButton && (
        <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[10002]">
          <button
            type="button"
            onClick={dismissAllMultipleModelWarningToasts}
            className="rounded bg-red-100 px-3 py-1 text-xs font-medium text-red-700 hover:bg-red-200"
          >
            Dismiss All
          </button>
        </div>
      )}
      <Toaster
        visibleToasts={6}
        toastOptions={{
          style: {
            top: "30px",
          },
          className:
            "font-myriad absolute min-w-max w-fit text-base h-11 flex justify-center",
        }}
        position="top-center"
        richColors
        theme="light"
        closeButton
        duration={3000}
        gap={6}
      />
    </div>
  );
}
export default ToastNotification;
